module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-MediumItalic-5bca7415ad42795776b7b735b2b06c89.ttf";